// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2PJ7A","actions":"GroupTable_actions__3-NUZ","deleteModalFooter":"GroupTable_deleteModalFooter__H7EyM"};